import Blog10image1 from "../../assets/Blog10Image1.avif";
import Blog10image2 from "../../assets/Blog10Image2.avif";
import Blog10image3 from "../../assets/Blog10Image3.avif";
import Blog10image4 from "../../assets/Blog10Image4.avif";
import Blog10image5 from "../../assets/Blog10Image5.avif";
import Blog10image6 from "../../assets/Blog10Image6.avif";
import Blog10image7 from "../../assets/Blog10Image7.avif";
import Blog10image8 from "../../assets/Blog10Image8.avif";
import Blog10image9 from "../../assets/Blog10Image9.avif";
import Blog10image10 from "../../assets/Blog10Image10.avif";
import Blog10image11 from "../../assets/Blog10Image11.avif";
import Blog10image12 from "../../assets/Blog10Image12.avif";
import Blog10image13 from "../../assets/Blog10Image13.avif";
import Blog10image14 from "../../assets/Blog10Image14.avif";
import Blog10image15 from "../../assets/Blog10Image15.avif";
import Blogimage10 from "../../assets/Blogimage10.avif";
import Navbar from "../../components/landing-page/LandingPageNavbar";
import { useNavigate } from "react-router-dom";

function Blog10() {
    const navigate = useNavigate();
    const handleClick = (path: string) => {
      navigate(`/${path}`);
    };
    const handleNavigate = (url: string) => {
      window.open(url, "_blank");
    };
  return (
    <div className="bg-[#F9F9F9]">
      <Navbar />
    <div className="min-h-screen w-full flex justify-center">
      <div className="flex flex-col items-center w-[90%] sm:w-[80%] md:w-[80%] lg:w-[80%] xl:w-[60%] mt-10 px-3 sm:px-4 md:px-6 lg:px-6 py-4 sm:py-8 md:py-10 ">
        <div className="flex items-center justify-between w-full text-sm sm:text-base mb-4">
          <span>Jan 18, 2022 7 min read</span>
          {/* <button className="px-4 py-2 bg-blue-500 text-white rounded">
            Click
          </button> */}
        </div>
        <div className="w-full text-xl sm:text-2xl md:text-3xl lg:text-4xl font-semibold mb-4">
          Building blocks of a perfect pitch deck
        </div>

        <p className="w-full text-base leading-relaxed mb-2 mt-6">
          Over the past few years, there has been a lot of conversation around
          pitch decks. It has become an integral part of starting up and remains
          so throughout a company’s journey from a brilliant idea to going
          public. They have become so vital that founders work on creating a
          pitch deck even before they have a lot of other things figured out
          around their business. And this is not entirely counter-intuitive. A
          pitch deck is not only essential for communicating how different
          aspects of your business are tied together and raising funds, but also
          provide a solid and structured ground for brainstorming ideas. Ideas
          are often complex in one’s mind and communicating them through a
          structured approach not only makes the pitch effective, but also helps
          in developing a short to medium term vision for the business. As a
          business evolves, it keeps generating data points which convey the
          health of the company and hence makes it easier to communicate the
          same to various stakeholders. However, in early stages there is a lack
          of qualified information around the business and hence it is mostly
          speculation. This is where a structured pitch deck can help
          communicate that story effectively.
        </p>
        <p className="w-full text-base leading-relaxed mb-2 mt-4">
          So, we thought we would look at early stage pitch decks of some of the
          most successful startups in recent history and see if we can identify
          some patterns. And we did. The pitch decks we analyzed had a lot of
          things in common and followed a similar structure to communicate
          different aspects of their business.
        </p>

        <div className="flex h-[70vh] w-full mb-6 mt-4">
          <img
            src={Blogimage10}
            alt="Blog Cover"
            className="object-cover w-full h-full rounded"
          />
        </div>
        <div className="w-full text-2xl sm:text-2xl md:text-2xl lg:text-2xl font-semibold mb-2 mt-4">
          Pitch deck is the Tinder profile of your startup
        </div>
        <p className="w-full text-base leading-relaxed mb-2 mt-6">
          On an average, a pitch deck is 16 pages long. Whereas an investor
          spends an average of only 4 minutes reviewing it. This implies that
          they spend an average of 15 seconds on any given page of a pitch deck.
          Hence it is extremely important to concisely and effectively
          communicate the information on that page using visual cues. At the
          same time, typically less than 2% pitch deck emails receive a response
          from an investor. To bring some perspective to this number, the
          average match rate on tinder is around 3.5%. So, if you thought
          finding matches on Tinder is difficult, then raising funds is a tad
          more challenging. With a pitch deck acting as your Tinder profile, you
          need to put your best foot forward and ensure that your profile comes
          across as an organized, uncomplicated and forward thinking company to
          get that date with an investor.
        </p>

        <div className="w-full text-2xl sm:text-2xl md:text-2xl lg:text-2xl font-semibold mb-2 mt-4">
          Our analysis and recommended structure
        </div>

        <p className="w-full text-base leading-relaxed mb-2 mt-6">
          For the purpose of this study, we analyzed the structure of early
          stage pitch decks of 30 multi-billion dollar startups from before they
          turned into a unicorn. These startups are now industry leaders and
          represent a diverse set of industries. The pitch decks we analyzed as
          part of this study were used for their pre-seed and seed fundraising.
        </p>
        <p className="w-full text-base leading-relaxed mb-2 mt-6">
          As mentioned earlier, investors do not spend a lot of time on initial
          review of a pitch deck. Hence, it’s important to keep the deck concise
          and to the point to make the most of their attention. They need to
          process a lot of data and information, so it’s important to
          communicate the same through simple infographics and keep it short.
          The pitch decks we analyzed had a median of 14 slides.
        </p>

        <div className="flex h-[60vh] w-full mb-6">
          <img
            src={Blog10image1}
            alt="Blog Cover"
            className="object-cover w-full h-full rounded"
          />
        </div>
        <p className="w-full text-base leading-relaxed mb-2 mt-6">
          We further analyzed the contents of the pitch decks and recommend
          including the following sections in the deck:
        </p>
        <div className="flex h-[60vh] w-full mb-6">
          <img
            src={Blog10image2}
            alt="Blog Cover"
            className="object-cover w-full h-full rounded"
          />
        </div>

        <ul className="list-decimal list-inside space-y-4 text-sm sm:text-base leading-relaxed mt-4">
          <li>
            {" "}
            <span className="font-semibold">Problem: </span>
            The problem that you are trying to solve forms the basis of your
            pitch deck as all the other sections need to explain why and how you
            would be able to solve that problem. In most cases, founders miss
            out on explaining the problem areas comprehensively, which reduces
            the investor conviction that they would be able to solve them. A
            good problem statement should convey what the problem is, who is
            facing that problem and what is the impact of that particular
            problem on the stakeholders involved. Quantification of the impact
            helps in understanding the scale of the problem.
            <div className="flex h-[50vh] w-full mb-6">
              <img
                src={Blog10image3}
                alt="Blog Cover"
                className="object-cover w-full h-full rounded"
              />
            </div>
          </li>
          <li>
            {" "}
            <span className="font-semibold">Solution: </span> The solution slide
            of the deck helps the investors understand how you intend to solve
            the given problem. This section should talk about the value
            propositions of the intended solution and should be directly linked
            with the problem areas. At the same time, a frequent question asked
            by investors is why a solution like this has not been implemented so
            far. Or why is it a good time to implement it now? The answer to
            such questions should point to the challenges that existed up till
            now to implement such a solution and how you plan to alleviate them.
            <div className="flex h-[60vh] w-full mb-6">
              <img
                src={Blog10image4}
                alt="Blog Cover"
                className="object-cover w-full h-full rounded"
              />
            </div>
          </li>
          <li>
            {" "}
            <span className="font-semibold">Market & Opportunity: </span> This
            section gives you an opportunity to explain the potential of your
            startup to the investors. The market size for a particular business
            indicates the potential scale it can reach. Investors are generally
            looking for companies that would provide them with 100x returns, so
            the market size becomes an important piece of information around the
            possibility of that happening. Most founders end up putting some
            random numbers here picked up from the internet. However, you need
            to be able to justify those multi-billion market size numbers and
            explain how your solution caters to such a large market. One of the
            most common ways to depict the market size is through the
            TAM/SAM/SOM analysis. The total addressable market (TAM) indicates
            the entire market your solution can potentially cater to. The
            serviceable addressable market (SAM) indicates the immediately
            serviceable market with your current offerings. Lastly, the
            serviceable obtainable market (SOM) is the share of the market that
            you can capture right away. Breaking down the market into smaller
            parts also conveys to the investors that you understand the market
            you are operating in.
            <p className="mt-4">
              That being said, the market size number alone only gives half the
              picture. Another important metric to be provided here is the
              growth of the market. While you may be operating in a large
              market, if it is not growing at a steady pace then it might not be
              as lucrative for investors. At early stages, a small but growing
              market might be more promising than a large stagnant market.
            </p>
            <div className="flex h-[60vh] w-full mb-6">
              <img
                src={Blog10image5}
                alt="Blog Cover"
                className="object-cover w-full h-full rounded"
              />
            </div>
            <div className="flex h-[60vh] w-full mb-6">
              <img
                src={Blog10image6}
                alt="Blog Cover"
                className="object-cover w-full h-full rounded"
              />
            </div>
          </li>
          <li>
            {" "}
            <span className="font-semibold">Product/Service: </span>This section
            is the extension of your solution and should talk about the products
            or services built around the proposed solution. You can get into the
            details of your offerings here and the specifications of the product
            that you plan on developing. It is a good practice to provide
            use-cases of your products / services to help the investors’ and
            other stakeholders imagine the practical application and
            implementation of the same. At the same time, if you have visibility
            on how your product evolves over time, you should present a product
            roadmap as well. This allows the investors to gauge if you have a
            long-term vision for your business and can plan for the future.
            <div className="flex h-[60vh] w-full mb-6">
              <img
                src={Blog10image7}
                alt="Blog Cover"
                className="object-cover w-full h-full rounded"
              />
            </div>
          </li>
          <li>
            {" "}
            <span className="font-semibold">Business Model: </span>The business
            model section is where you need to explain how you will be able to
            monetize your services. You may have a solid solution and a
            well-planned product roadmap to implement that solution, however if
            you do not have a way to monetize your products / services, then
            there is no business. An ideal business model should cover the
            products or services that you intend to monetize, who would be
            paying for those services, and what they would be paying for the
            same.
            <div className="flex h-[60vh] w-full mb-6">
              <img
                src={Blog10image8}
                alt="Blog Cover"
                className="object-cover w-full h-full rounded"
              />
            </div>
          </li>
          <li>
            {" "}
            <span className="font-semibold">Go-to-market Strategy</span>This is
            one of the most important sections of the pitch deck and at the same
            time one section that founders struggle with the most. A
            go-to-market strategy need not be some shiny slide with fancy text
            and graphics. It needs to be a simple plan to take your products and
            services to your intended users. There are three primary elements of
            any comprehensive go-to-market strategy. The first one is
            well-defined customer segments and personas. Second, a pricing model
            for each of the segments. Third, relevant channels to reach out to
            the intended audience. Once you have these three things in place,
            tying them together creates your go-to-market strategy.
            <div className="flex h-[60vh] w-full mb-6">
              <img
                src={Blog10image9}
                alt="Blog Cover"
                className="object-cover w-full h-full rounded"
              />
            </div>
          </li>
          <li>
            {" "}
            <span className="font-semibold">Traction: </span>Up till this point,
            all you have is a plan in terms of a proposed solution, a good
            market, products and services, a business model and a marketing
            plan. The next step is to show that this plan actually works and
            there is no better way to showcase that than by showing the customer
            and usage numbers. Traction could be depicted in various forms
            depending on your product and business model. The most common way to
            depict it is using the number of users and customers your business
            has acquired. Other ways to show growth are through partnerships,
            usage metrics, revenue, etc. You should also use this section to
            show the planned milestones for your business so that investors can
            align with similar business or financial goals.
            <div className="flex h-[60vh] w-full mb-6">
              <img
                src={Blog10image10}
                alt="Blog Cover"
                className="object-cover w-full h-full rounded"
              />
            </div>
          </li>
          <li>
            {" "}
            <span className="font-semibold"> Competitive landscape:</span> Every
            business at some point or the other goes through a competitive
            analysis. It could have happened while reading up news articles
            about your competitors or planning your products and services or
            actually doing an in-depth analysis to identify gaps in the market.
            This section also becomes important from the perspective of
            communicating to the potential investors that you know your market
            and what you are getting into. There are various ways in which you
            can depict the landscape depending on your market. However, just
            listing the names of your competitors doesn’t suffice. You need to
            explain your moats or your competitive advantage against similar
            players in the market. The moats can be in terms of low-costs, high
            switching costs, network effects and intangible assets like IP,
            patents, etc.
            <div className="flex h-[60vh] w-full mb-6">
              <img
                src={Blog10image11}
                alt="Blog Cover"
                className="object-cover w-full h-full rounded"
              />
            </div>
            <div className="flex h-[65vh] w-full mb-6">
              <img
                src={Blog10image12}
                alt="Blog Cover"
                className="object-cover w-full h-full rounded"
              />
            </div>
          </li>

          <li>
            {" "}
            <span className="font-semibold">Team: </span> This is the most
            straight-forward section in the pitch deck. No research or analysis
            required. Presenting the details of the founding team in the pitch
            deck tells the investors why you are the right set of people to be
            doing this. Things that should be highlighted here are your past
            experience in the given market, your academic credentials to help
            you come up with ingenious solutions and key insights that you might
            have about this space. In addition to this, putting up faces behind
            the company on a slide also helps in communicating that your company
            is something beyond data and figures with real people building real
            things.
            <div className="flex h-[60vh] w-full mb-6">
              <img
                src={Blog10image13}
                alt="Blog Cover"
                className="object-cover w-full h-full rounded"
              />
            </div>
          </li>
          <li>
            {" "}
            <span className="font-semibold">
              Financial projections and ask:
            </span>
            This is the section where everything culminates. If you are able to
            hold the investors’ attention till now, then you have already done
            better than 99% of the pitch decks. Prior to this section, you have
            explained all the different aspects of your business and tried to
            communicate why this is something exciting. In this section you have
            to talk about hard numbers and figures and show the investors why
            this is going to give them that 100x return on investment. You
            should try providing two to five years of financial projections to
            give them visibility over different revenue streams and cost
            centers. Based on these projections, you should provide your
            fundraising ask in terms of the total funds you are looking to raise
            in this investment cycle. Lastly, you should provide a use of funds
            in terms of where major expenses will happen till your next
            fundraising round. If these numbers look believable and achievable,
            the investors would not want to pass up on the opportunity to invest
            in you and your company.
            <div className="flex h-[60vh] w-full mb-6">
              <img
                src={Blog10image14}
                alt="Blog Cover"
                className="object-cover w-full h-full rounded"
              />
            </div>
            <div className="flex h-[60vh] w-full mb-6">
              <img
                src={Blog10image15}
                alt="Blog Cover"
                className="object-cover w-full h-full rounded"
              />
            </div>
          </li>
        </ul>

        <p className="w-full text-base leading-relaxed mb-2 mt-4">
          Generative AI is not limited to text and layout design in pitch deck
          creation. Its applications have stretched to many areas, enhancing the
          overall process and outcome. Creating an effective pitch deck involves
          researching prospects, focusing your message, enhancing design, using
          data, creating emotional connections, and reviewing your pitch.
        </p>

        <ul className="list-decimal list-inside space-y-6 text-base sm:text-base leading-relaxed mt-6">
          <li>
            {" "}
            <span className="font-semibold">Brainstorming Partner: </span>{" "}
            <p className="mt-4">
              Generative AI can serve as your virtual brainstorming partner,
              pushing the boundaries of ideas and can suggest innovative
              approaches. Generating new ideas can be challenging to teams to
              think more and widely about what can be added in a pitch deck.
            </p>
          </li>
          <li>
            {" "}
            <span className="font-semibold">
              Your research assistant:{" "}
            </span>{" "}
            <p>
              AI can also be your research assistant, it can recommend relevant
              sources to support your pitch deck’s content. These
              AI-recommendations and its sources can be cross-checked manually,
              ensuring the validity of information.
            </p>
          </li>
          <li>
            {" "}
            <span className="font-semibold">Focus on your message </span>{" "}
            <p>
              When you’re creating your pitch deck, make sure it conveys the
              main idea - that way, You won’t be overwhelmed. You can add some
              inputs to your AI generative tool in the form of key takeaways,
              But make sure to focus on the main points. The statement should
              include two important
            </p>
            <ul className="list-disc list-inside space-y-1 text-base sm:text-base leading-relaxed mt-2">
              <li>A user pain point </li>
              <li>The solution you’re offering for that pain point</li>
            </ul>
          </li>
          <li>
            {" "}
            <span className="font-semibold">Image generation </span>{" "}
            <p className="mt-4">
              You can use generative AI to produce unique images, enriching the
              visual aspects of pitch deck. An aesthetically pleasing and
              well-thought out pitch deck design can significantly impact the
              effectiveness of your pitch deck. Neglecting the design can
              undermine the overall impression in the eyes of the investors even
              though you have a compelling business proposition.
            </p>
            <p className="mt-4">
              Ensure consistency in terms of branding and design to build brand
              awareness. Keep your design clean, simple, and uncluttered. Avoid
              excessive text or complex visuals, use concise bullet points,
              clear headings and impactful imagery like infographics.
            </p>
            <p className="mt-4">
              Avoid generic stock photos and videos at all costs. Instead, use
              relevant images that align with your brand and message. Pick
              subtle animations that create a sense of movement. Ensure that the
              text in the pitch is easily readable.
            </p>
          </li>
        </ul>

        <p className="w-full text-base leading-relaxed mb-2 mt-4">
          Happy Pitching!
        </p>
        <p className="w-full text-base leading-relaxed mb-2 mt-4">
          We have worked with more than 20 early-stage startups to help them
          with fundraising collateral, creating and overhauling their pitch
          documents, market research, financial planning and business design.
          Please feel free to reach out to us at   <span onClick={()=>handleNavigate("mailto:contact@parati.in")} className="underline text-[#1155CC] cursorpoi">
                {" "}
                contact@parati.in{" "}</span> if you need
          help with your fundraising strategy and documents.
        </p>
      </div>
    </div>
    </div>
  );
}

export default Blog10;
